import React from 'react'
import './Popup.css'
class Popup extends React.Component{

    componentDidMount() {
        document.addEventListener('click', this.onDocumentClick);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    }

    render() {
        return <div className='popup-darker'>
            <div className='popup-container'>
                <div className='popup-header' />
                {this.props.html ? <div className='text-30' dangerouslySetInnerHTML={{__html: this.props.children}} /> : <p className='text-30'><b>{this.props.children}</b></p>}
                <div className='popup-container-button'>
                    {this.props.isButtonInactive ?
                        ""
                        :   <button className='main-btn' onClick={ () => { this.props.onClose && this.props.onClose(); }}>OK</button>}

                </div>

            </div>


    </div>;
    }
}

export default Popup;
